import api from '@/api'

export default {
    publish(template: webpartv3.WebpartTemplate): Promise<webpartv3.UserCacheVersion> {
        return api.post<webpartv3.UserCacheVersion>({
            url: '/Webpart/WebpartPersonal/api/create',
            data: template,
        })
    },

    /**
     * 웹파트 개인화 설정을 제거합니다.
     */
    delete(): Promise<webpartv3.UserCacheVersion> {
        return api.get<webpartv3.UserCacheVersion>({
            url: '/Webpart/WebpartPersonal/api/delete',
        })
    }
}
